import React from "react";
import "./style.css";
import australiaImage from "../../assets/australia.webp";
import Particles from "../Particles/Particles";
import university1 from "../../assets/university-logos/australia/Australian_National_University.webp";
import university2 from "../../assets/university-logos/australia/Univerisity_of_Melbourne.webp";
import university3 from "../../assets/university-logos/australia/Univerisity_of_Sydney.webp";
import university4 from "../../assets/university-logos/australia/University_of_New_South_Wales.webp";
import university5 from "../../assets/university-logos/australia/University_of_Western_Australia.webp";

const universityList = [
  { id: Math.random(), image: university1 },
  { id: Math.random(), image: university2 },
  { id: Math.random(), image: university3 },
  { id: Math.random(), image: university4 },
  { id: Math.random(), image: university5 },
];

const Australia = () => {
  return (
    <>
      <Particles
        title="Study in Australia"
        subTitle="Start Your Journey to the Australia Today"
        image={australiaImage}
      />
      <div className="short-description container">
        <h1 className="text-left">Study in Australia</h1>
        <p className="text-justify">
          Australia has always welcomed international students and considers
          them an important part of its community and economy. The country is
          known for its modern lifestyle, multicultural environment, and strong
          global presence. With a wide variety of food, cultures, religions, and
          languages, Australia offers a rich and diverse experience, making it
          one of the most popular destinations for students from around the
          world. Australia is divided into six states, and each one is home to
          top universities and colleges that provide high-quality education to
          thousands of international students every year. English is the
          official language, but Australian English includes some unique words
          and phrases that you’ll enjoy learning.
          <br /> <br />
          <strong>Educraft Education Network</strong> has been helping Nepali
          students apply for student visas and gain admission to Australian
          colleges and universities for years. We are dedicated to guiding
          students who want to study abroad and explore global academic
          opportunities. In today’s world, people are increasingly moving beyond
          their home countries in search of better education and career options.
          Australia has become a popular choice for many of these students
          because of its world-class education, supportive environment, and
          excellent future prospects. At Educraft, we support you at every step
          — from choosing the right course and university to preparing your
          documents and applying for your visa. Our experienced team is here to
          make your study journey to Australia smooth, safe, and successful.
        </p>
      </div>

      <div className="why-study container">
        <h1 className="text-left">Why study in Australia? </h1>
        <p className="text-left">
          Australia is widely celebrated as one of the world’s top destinations
          for international students. Here’s why learners from every corner of
          the globe are drawn to study there:
        </p>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="first-tab"
              data-bs-toggle="tab"
              data-bs-target="#first"
              type="button"
              role="tab"
              aria-controls="first"
              aria-selected="true"
            >
              Top-Quality Education
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="second-tab"
              data-bs-toggle="tab"
              data-bs-target="#second"
              type="button"
              role="tab"
              aria-controls="second"
              aria-selected="false"
            >
              Variety with Flexibility
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="third-tab"
              data-bs-toggle="tab"
              data-bs-target="#third"
              type="button"
              role="tab"
              aria-controls="third"
              aria-selected="false"
            >
              Bright Career
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="fourth-tab"
              data-bs-toggle="tab"
              data-bs-target="#fourth"
              type="button"
              role="tab"
              aria-controls="fourth"
              aria-selected="false"
            >
              Multicultural & Open-Minded
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane show active"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <h6>
              Australian universities consistently rank among the top
              institutions globally, recognized for their high academic
              standards and commitment to excellence in teaching and research.
              These universities offer rigorous and comprehensive programs
              across a wide range of disciplines, ensuring students receive a
              quality education that challenges and develops critical thinking,
              problem-solving, and practical skills.
              <br />
              <br /> Moreover, Australian institutions are at the forefront of
              innovative research, providing students with access to
              cutting-edge facilities, technology, and collaboration
              opportunities with industry leaders and global experts. This
              emphasis on research not only enhances learning but also
              contributes to advancements in science, technology, health, and
              many other fields. Degrees awarded by Australian universities are
              internationally respected and recognized by employers and
              educational institutions around the world. Graduates benefit from
              enhanced career prospects, both within Australia and globally, due
              to the strong reputation and credibility of their qualifications.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="second"
            role="tabpanel"
            aria-labelledby="second-tab"
          >
            <h6>
              Australian universities offer thousands of diverse programs
              spanning a wide array of fields, including engineering, health
              sciences, business, information technology, the arts, and many
              more. This extensive range allows students to find courses that
              perfectly align with their individual passions and career
              aspirations. Whether a student is interested in cutting-edge
              technological innovation, creative arts, healthcare, or
              entrepreneurship, there are tailored programs designed to meet
              those needs.
              <br />
              <br /> Furthermore, many institutions provide flexible study
              options, including majors, minors, electives, and
              interdisciplinary courses, enabling students to customize their
              education. This personalized approach ensures that learners can
              develop both deep expertise and a broad skill set, making them
              well-prepared for the dynamic demands of today’s job market.
              Additionally, students have access to practical experiences such
              as internships, industry placements, and research projects, which
              help bridge academic knowledge with real-world applications. This
              combination of diverse programs and practical learning
              opportunities empowers students to shape their education in a way
              that supports their long-term professional goals and personal
              growth.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="third"
            role="tabpanel"
            aria-labelledby="third-tab"
          >
            <h6>
              Many Australian university programs are designed with strong links
              to industry, often including mandatory or optional placements,
              internships, and cooperative education opportunities. These
              hands-on experiences allow students to apply their academic
              knowledge in real-world work environments, develop practical
              skills, and build professional networks before graduation.
              <br />
              <br /> In addition to gaining valuable work experience during
              their studies, international graduates from Australian
              institutions frequently qualify for favorable post-study work
              visas. These visas provide extended opportunities to remain in
              Australia after completing their degrees, enabling them to further
              enhance their professional experience, explore career pathways,
              and establish themselves in the global job market. Such pathways
              significantly boost graduates’ employability both within Australia
              and internationally. Employers worldwide recognize the combination
              of high-quality education and practical industry experience that
              Australian graduates possess, making them competitive candidates
              for a wide range of roles across various sectors.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="fourth"
            role="tabpanel"
            aria-labelledby="fourth-tab"
          >
            <h6>
              Australia is a truly multicultural nation, proudly welcoming
              people from over 200 different countries. This diverse population
              contributes to a rich cultural mosaic that is reflected in every
              aspect of Australian life. For international students, this means
              being part of a community that values inclusivity and celebrates
              cultural diversity.
              <br />
              <br /> The country hosts a wide variety of vibrant cultural events
              throughout the year — from traditional festivals, food fairs, art
              exhibitions, and music performances to community gatherings that
              showcase the customs and traditions of different ethnic groups.
              These events provide students with excellent opportunities to
              experience and engage with cultures from around the world, helping
              them feel at home far from their native countries. Additionally,
              Australian universities and communities offer extensive student
              support services designed to help international students adapt and
              thrive. These include orientation programs, language assistance,
              counseling, academic support, career guidance, and social clubs —
              all aimed at making the student experience smooth, rewarding, and
              enjoyable.
              <br />
              <br /> Above all, Australia is known for its safe and welcoming
              atmosphere. The general friendliness of locals, combined with
              strict safety standards and laws, ensures that students feel
              secure living and studying here. This supportive environment
              fosters a sense of belonging and well-being, encouraging students
              to focus on their studies and personal growth.
            </h6>
          </div>
        </div>
      </div>

      <div className="university-partners container">
        <h1 className="text-left">Our University Partner in Australia</h1>
        <div className="row">
          {universityList?.map((list) => (
            <div key={list.id} className="col-6 col-md-4 col-lg-3 p-2">
              <div className="partner-box">
                <img src={list.image} alt="university logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Australia;
